import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { PercenProbArea } from "./Styles";

export default function PercentProb({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="% Probabilidad*"
            value={!value ? document.probability.percentage.text : value}
          />
        </div>
      ) : (
        <PercenProbArea>
          <Informative
            readonly={true}
            label="% Probabilidad*"
            value={!value ? document.probability.percentage.text : value}
          />
        </PercenProbArea>
      )}
    </>
  );
}
